import styled from 'styled-components';
import { themes } from 'kb-shared';

export const Title = styled.div`
  ${themes.fonts.DomaineDisplay};
  font-size: 36px;
  color: ${themes.colors.KBNight};
  text-align: center;
  margin-bottom: 28px;

  @media screen and (min-width: ${themes.breakpoints.tabletPortrait}) {
    text-align: left;
    font-size: 48px;
  }
`;

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
`;

export const PageInfo = styled.div`
  ${themes.fonts.FoundersGrotesk}
  color: #353148;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
`;
